import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/Button/CookieLayerLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsFilterProvider"] */ "/app/src/components/ContentElements/News/Provider/NewsFilterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DialogWindow/DialogToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DraftMode/ExitDraftModeLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layout/ConsentBarMargin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layout/Header/Navigation/MainNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavProvider"] */ "/app/src/components/Layout/Header/Navigation/MainNavProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layout/Header/Navigation/NavBurgerButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layout/Header/Navigation/NavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcherClient"] */ "/app/src/components/LocaleSwitcher/LocaleSwitcherClient.tsx");
